<template>
	<Surface :class="$style['grid-box-skeleton']">
		<div :class="$style['grid-box-skeleton__header']">
			<Rectangle height="20px" width="40%" />
			<Rectangle
				height="16px"
				width="25%"
				:custom="{ marginTop: '6px' }"
			/>
		</div>
		<div :class="$style['grid-box-skeleton__fields']">
			<div
				v-for="n in fieldCount"
				:key="n"
				:class="$style['grid-box-skeleton__field']"
			>
				<Rectangle
					height="11px"
					width="40%"
					:custom="{ marginBottom: '4px' }"
				/>
				<Rectangle height="16px" width="80%" />
			</div>
		</div>
	</Surface>
</template>

<script>
import Surface from '@/components/Essentials/Surface'
import { Rectangle } from '@/components/Essentials/Skeleton'

export default {
	name: 'GridBoxSkeleton',
	components: {
		Surface,
		Rectangle
	},
	props: {
		fieldCount: {
			type: Number,
			default: 4
		}
	}
}
</script>

<style lang="scss" module>
	.grid-box-skeleton {
		display: flex;
		flex-flow: column;
		height: 100%;

		&__header {
			margin-bottom: $gutter * 1.5;
		}

		&__fields {
			display: flex;
			flex-wrap: wrap;
			gap: $gutter;
		}

		&__field {
			display: flex;
			flex-direction: column;
			min-width: 0;
			flex: 1 1 calc(50% - #{$gutter});
		}
	}
</style>
